var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109.333 13.3333H18.6665L26.6665 104L63.9998 114.667L101.333 104L109.333 13.3333Z",
    fill: "#0277BD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64 21.3333V106.4L93.8667 97.8666L100.533 21.3333H64Z",
    fill: "#039BE5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2667 34.6667H64V45.3334H77.0667L76.2667 56.0001H64V66.6667H75.7333L74.9333 78.6667L64 82.4001V93.6001L85.0667 86.6667L86.9333 56.0001L88.2667 34.6667Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9996 34.6667V45.3334H40.2663L39.4663 34.6667H63.9996ZM51.733 56.0001L52.2663 66.6667H63.9996V56.0001H51.733ZM52.7996 72.0001H42.133L42.933 86.6667L63.9996 93.6001V82.4001L53.0663 78.6667L52.7996 72.0001Z",
    fill: "#EEEEEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/css.d073907d88d12195376b3622ce21f1b8.svg";
export { ForwardRef as ReactComponent };